import { render, staticRenderFns } from "./ListWidgetPreview.vue?vue&type=template&id=45c1b3fd&scoped=true&"
import script from "./ListWidgetPreview.vue?vue&type=script&lang=js&"
export * from "./ListWidgetPreview.vue?vue&type=script&lang=js&"
import style0 from "./ListWidgetPreview.vue?vue&type=style&index=0&id=45c1b3fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1b3fd",
  null
  
)

export default component.exports